import User from '@/api/User'
import Functions from '@/functions'

export default {
  namespaced: true,
  state: {
    profile: null
  },
  mutations: {
    SET_PROFILE(state, data) {
      state.profile = data
    }
  },
  actions: {
    profile({ commit }, params) {
      return User.profile()
        .then((res) => {
          commit('SET_PROFILE', res.data.message.data)
        })
        .catch((error) => {
          Functions.httpErrorHandler(error)
          return { status: false, message: null }
        })
    }
  },
  getters: {}
}
